import React from 'react';
import {
  formatClassNameAsDateRange, getDateRangeString, ProfileCardSubtitle, ProfileCardTitle,
} from '@marageti/z4-lib';
import { AvailabilityLimitType, PartnerAvailability } from '@marageti/z4-sdk/lib/travel';
import { Chip, Typography, Card } from '@mui/material';

type EventCardProps = {
  availabilityItem: PartnerAvailability;
  capacity: number;
};

const EventCardView = ({ availabilityItem, capacity }: EventCardProps) => {
  const showFooter = availabilityItem.leadsPerWeek > capacity;
  return (
    <Card
      className={formatClassNameAsDateRange(availabilityItem?.startDate, availabilityItem?.endDate)}
      sx={{
        mb: 2,
        padding: '24px',
      }}
    >
      <ProfileCardTitle>
        {getDateRangeString(
          availabilityItem?.startDate,
          availabilityItem?.endDate,
        )}
      </ProfileCardTitle>
      <ProfileCardSubtitle>{availabilityItem.comments}</ProfileCardSubtitle>
      {availabilityItem.limitType === AvailabilityLimitType.LIMIT_TRAVEL && (
        <Chip
          sx={{
            backgroundColor: '#F9F9FB',
            borderRadius: '100px',
            border: '1px solid #C2C5C5',
            marginTop: 1.5,
            mr: 1,
          }}
          label="Limit Travel"
        />
      )}
      {availabilityItem.limitType === AvailabilityLimitType.LIMIT_LEADS && (
        <Chip
          sx={{
            backgroundColor: '#F9F9FB',
            borderRadius: '100px',
            border: '1px solid #C2C5C5',
            marginTop: 1.5,
          }}
          label={`Limit Leads (${availabilityItem.leadsPerWeek})${showFooter ? '*' : ''}`}
        />
      )}
      {showFooter && (
        <Typography sx={{ mt: 1.5 }} variant="subtitle1">
          *Maximum capacity has been lowered and will be used in place of this value.
        </Typography>
      )}
    </Card>
  );
};
export default EventCardView;
